import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { ButtonWithPopover } from '@/components/form/baseInputs/Button/ButtonWithPopover';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { MenuItem } from '@/components/poppers/MenuPopper/MenuItem';
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard';
import { useFormVersionConfigLazyQuery } from './AdminFormsPage.generated';
interface PublishedFormVersion {
  id: string;
  version: number;
}
interface FormVersionMenuProps {
  formName: string;
  currentVersion: number;
  versions: PublishedFormVersion[];
}
export function FormVersionMenu(t0) {
  const $ = _c(22);
  const {
    formName,
    currentVersion,
    versions
  } = t0;
  const [copyToClipboard] = useCopyToClipboard();
  const {
    showFeedback
  } = useFeedback();
  const [loadVersionConfig] = useFormVersionConfigLazyQuery();
  let t1;
  if ($[0] !== copyToClipboard || $[1] !== loadVersionConfig || $[2] !== showFeedback) {
    t1 = async version => {
      const result = await loadVersionConfig({
        variables: {
          id: version.id
        }
      });
      if (result.data?.node?.__typename !== "FormVersion") {
        throw new Error("Form version config was not returned");
      }
      copyToClipboard(JSON.stringify(result.data.node.config, null, 2), () => showFeedback(`Form version ${version.version} copied to clipboard`, {
        variant: "success"
      }), () => showFeedback(`Failed to copy form version ${version.version}`, {
        variant: "error"
      }));
    };
    $[0] = copyToClipboard;
    $[1] = loadVersionConfig;
    $[2] = showFeedback;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const copyVersion = t1;
  const t2 = String(currentVersion);
  const t3 = `Copy a published version of ${formName}`;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      px: 0
    };
    t5 = {
      anchorOrigin: {
        horizontal: "left",
        vertical: "bottom"
      },
      transformOrigin: {
        horizontal: "left",
        vertical: "top"
      }
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      minWidth: 144
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== copyVersion || $[8] !== currentVersion || $[9] !== showFeedback || $[10] !== versions) {
    let t8;
    if ($[12] !== copyVersion || $[13] !== currentVersion || $[14] !== showFeedback) {
      t8 = version_0 => <MenuItem key={version_0.id} label={`Version ${version_0.version}${version_0.version === currentVersion ? " (current)" : ""}`} onClick={() => {
        copyVersion(version_0).catch(() => showFeedback(`Failed to copy form version ${version_0.version}`, {
          variant: "error"
        }));
      }} />;
      $[12] = copyVersion;
      $[13] = currentVersion;
      $[14] = showFeedback;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    t7 = versions.map(t8);
    $[7] = copyVersion;
    $[8] = currentVersion;
    $[9] = showFeedback;
    $[10] = versions;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <Box sx={t6}>{t7}</Box>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t3 || $[20] !== t8) {
    t9 = <ButtonWithPopover label={t2} aria-label={t3} variant="transparent" size="xs" popperVariant="menuBelow" buttonSx={t4} popperProps={t5}>{t8}</ButtonWithPopover>;
    $[18] = t2;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}